const AGENT_SUPPLIER = 'Agent/Supplier';
const BUDGET_PRICE = 'Budget Price';
const CHILD_VERIFIED = 'childVerified';
const CHOOSE_COLLECTION = 'Choose Collection';
const DEFAULT_FORCE_UPDATE = 'DEFAULT_FORCE_UPDATE';
const DESCRIPTION = 'Description';
const DIMMING_PROTOCOL = 'Dimming Protocol';
const EFFICACY = 'Efficacy (lm/w)';
const ENVIRONMENT = 'Environment';
const ESTIMATED_DELIVERY = 'Estimated Delivery Date';
const ID = 'id';
const IMAGE = 'Image';
const INGRESS_CLASSIFICATION = 'Ingress Classification';
const LEAD_TIME = 'Lead Time (Weeks)';
const LIGHT_SOURCE_TYPE = 'Light Source Type';
const LOCATION = 'Location';
const LUMENS = 'Lumens';
const MANUFACTURER = 'Manufacturer';
const MANUFACTURER_DESCRIPTION = 'Manufacturer Description';
const MODEL = 'Model (Manufacturer Series Name)';
const MOUNTING = 'Mounting';
const ORIGIN = 'Origin';
const PRODUCT_CODE = 'Product Code';
const PRODUCT_NOTES = 'Product Notes';
const PRODUCT_REFERENCE = 'Product Reference';
const PRODUCT_TYPE = 'Product Type';
const PROJECT_NOTES = 'Notes - Project Specific';
const QUANTITY = 'Quantity';
const RELEASE_DATE = 'Release Date';
const SESSION = 'Session';
const SHIP_FROM = 'Ship from';
const SHOP_DRAWING_COMMENTS = 'Shop Drawing Review Comments';
const SORTING_COEFFICIENT = 'sortingCoefficient'; // sorting option only, not a header
const SPEC_SHEET_LINK = 'Specification Sheet Link';
const TAG = 'Tag';
const TIPS_AND_TRICKS = 'Tips and Tricks';
const TOTAL_COST = 'Total Cost';
const TOTAL_POWER = 'Total Power (Watts)';
const TYPE_DESIGNATION = 'Type / Designation';
const VERIFIED = 'isVerified';
const VERIFIED_PAGE_ID = 'verifiedPageId';
const VERIFIED_PAGE_NAME = 'verifiedPageName';
const VERSION = 'Version';
const VOLTAGE = 'Voltage';
const WATTAGE = 'Wattage';
const WEBSITE_LINK = 'Website Link';

const DISABLED_IN_SETTINGS = [TYPE_DESIGNATION];

/**
 * @deprecated
 */
const SHOP_DRAWINGS = 'Shop Drawings';

/**
 * @deprecated
 */
const DRAWING_UPLOADED_DATE = 'Drawing Uploaded Date';

/**
 * https://app.asana.com/0/1205146388025688/1207898211310102
 * 'Manufacturer' and 'Model (Manufacturer Series Name)'
 *
 * The 'requiredFields' on the schema should be checked first before we use this.
 */
export const DEFAULT_PRODUCT_REQUIRED_FIELDS = [
  'B', 'AO',
];

export const SCRAPING_HEADERS = [
  BUDGET_PRICE,
  IMAGE,
  MODEL,
  MANUFACTURER,
  MANUFACTURER_DESCRIPTION,
  PRODUCT_CODE,
  SPEC_SHEET_LINK,
];

// This value must be synced with updateCell lambda in terraform-infra.
export const IMPORT_LINK_COLUMN = 'ImportLinkUpdate';

export default {
  AGENT_SUPPLIER,
  BUDGET_PRICE,
  CHOOSE_COLLECTION,
  CHILD_VERIFIED,
  DEFAULT_FORCE_UPDATE,
  DESCRIPTION,
  DIMMING_PROTOCOL,
  DISABLED_IN_SETTINGS,
  DRAWING_UPLOADED_DATE,
  EFFICACY,
  ENVIRONMENT,
  ESTIMATED_DELIVERY,
  ID,
  IMAGE,
  INGRESS_CLASSIFICATION,
  LEAD_TIME,
  LIGHT_SOURCE_TYPE,
  LOCATION,
  LUMENS,
  MANUFACTURER,
  MANUFACTURER_DESCRIPTION,
  MODEL,
  MOUNTING,
  ORIGIN,
  PRODUCT_CODE,
  PRODUCT_NOTES,
  PRODUCT_REFERENCE,
  PRODUCT_TYPE,
  PROJECT_NOTES,
  QUANTITY,
  RELEASE_DATE,
  SESSION,
  SHIP_FROM,
  SHOP_DRAWINGS,
  SHOP_DRAWING_COMMENTS,
  SORTING_COEFFICIENT,
  TAG,
  TIPS_AND_TRICKS,
  TOTAL_COST,
  TOTAL_POWER,
  TYPE_DESIGNATION,
  VERIFIED,
  VERIFIED_PAGE_ID,
  VERIFIED_PAGE_NAME,
  VERSION,
  VOLTAGE,
  WATTAGE,
  WEBSITE_LINK,
};